import {
  takeLatest,
  call,
  all,
  put,
} from 'redux-saga/effects';
import noop from 'lodash/noop';

import types from '../types';
import actions from '../actions';
import appActions from '../../appWrapper/actions';

import { postAccreditationApi } from '../../api';

export function* postDataFlow(action) {
  const {
    data,
    promise: {
      resolve = noop,
      reject = noop,
    } = {},
  } = action;

  try {
    const {
      data: responseData,
    } = yield call(postAccreditationApi, data);

    yield all([
      call(resolve, responseData),
      put(
        actions.userAccreditationSucceeded(responseData),
      ),
      put(
        appActions.getUserDataRequested(),
      ),
    ]);
  } catch (error) {
    yield all([
      call(reject, error),
      put(
        actions.userAccreditationFailed(error),
      ),
    ]);
  }
}

export function* watchUserAccreditationRequested() {
  yield takeLatest(
    types.USER_ACCREDITATION_REQUESTED,
    postDataFlow,
  );
}

export default watchUserAccreditationRequested;
